var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{staticStyle:{},attrs:{"value":_vm.model,"row":""}},_vm._l((_vm.radioList),function(item,i){return _c('v-radio',{key:i,attrs:{"color":"#338A68","label":item.label,"value":item.label},on:{"click":function($event){return _vm.onHandle(item.label)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }